import {  IAugmentedJQueryStatic } from 'angular';
import jquery from 'jquery';

// replace jqLite with full JQuery, this expandes the selectors that can be used with angular.element and add additional jQuery methods.
// see: https://docs.angularjs.org/api/ng/function/angular.element
// TODO: eliminate need for all uses of full JQuery in favor of jqLite

// extend window typings for JQuery.
declare global {
    interface Window {
        jQuery: IAugmentedJQueryStatic
        $: IAugmentedJQueryStatic
    }
}

window.jQuery = jquery;
window.$ = jquery;

